module.exports = __webpack_public_path__ + "static/media/bow-arrow.5024f71f.svg";